export enum INSURANCE_PROVIDER_LOOKUP_TYPE {
  MEDICAL_INSURANCE = 'M',
  DENTAL_INSURANCE = 'D',
  SELF_PAY = 'S',
  LIEN = 'L',
  AUTO_INSURANCE = 'A',
  WORKERS_COMP_INSURANCE = 'W',
  RESEARCH = 'R',
  INMATE = 'I',
}
